import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M12 21.6534L6.34619 15.9995L7.41539 14.9303L12 19.4957L16.5846 14.9303L17.6538 15.9995L12 21.6534ZM7.43079 9.05335L6.34619 7.99953L12 2.3457L17.6538 7.99953L16.5692 9.05335L12 4.50335L7.43079 9.05335Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map